import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import type { PrinterMachineDisableValidationSchema } from "../../../features/printerMachines/schemas/printerMachineActions.schema";
import { privateAxios } from "../../api/axios";

interface UsePrinterMachineDisableProps {
  printerMachineId: string;
  onSuccess: () => void;
  onError: (error: any) => void;
}

export const usePrinterMachineDisable = ({ printerMachineId, onSuccess, onError }: UsePrinterMachineDisableProps) => {
  return useMutation<void, AxiosError, PrinterMachineDisableValidationSchema>({
    mutationKey: ['disablePrinterMachine', printerMachineId],
    mutationFn: (data) =>
      privateAxios.put(`/printer/machines/${printerMachineId}/disable`, {
        machine: {
          disable_reason: data.disable_reason,
        },
      }),
    onSuccess,
    onError,
  });
};